import React from 'react';
import './inputFieldLength.scss';

const InputFieldMxLength = ({ minValue, maxValue, valueLength }) => {
    return (
        <div className="input_field_value">
            {minValue && (
                <div className="min_value">
                    <span className='form_note'>Enter at least {minValue} characters</span>
                </div>
            )}
            {maxValue && (
                <div className={`max_value ${valueLength === maxValue && 'active'}`}>
                    <span className='form_note'>
                        {valueLength}/{maxValue}
                    </span>
                </div>
            )}
        </div>
    );
};

export default InputFieldMxLength;